// src/js/components/Evaluation/Results.js
import React, { Component } from "react";
import { connect } from "react-redux";
import renderHTML from "react-render-html";
import BenchmarkBarElement from "./BenchmarkBarElement";
import BenchmarkBarArrow from "./BenchmarkBarArrow";
import BenchmarkLegend from "./BenchmarkLegend";

import './ActionPlanSubmodule.css';

const mapStateToProps = state => {
    return {
        actionplan: state.data.actionplan.modules
    };
};

function mapDispatchToProps(dispatch) {
    return {};
}

class ConnectedActionPlanSubmodule extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let submodulearrayindex = parseInt(this.props.submoduleindex,10) - 1;
        let thisactionplan = this.props.actionplan[this.props.moduleindex].submodules[submodulearrayindex];

        // set the background-color for action items and status response
        let apstatus = "Not Commenced";
        let apcolor = "red";
        const tdate = new Date();
        let displayDate = `${tdate.getDate()}/${tdate.getMonth()+3}/${tdate.getFullYear()}`;
        if (this.props.submodule.average > 75) {
            apstatus = "Completed";
            apcolor = "green";
            displayDate = `${tdate.getDate()}/${tdate.getMonth()+1}/${tdate.getFullYear()}`;
        } else if (this.props.submodule.average > 50) {
            apstatus = "Commenced";
            apcolor = "yellow";
            displayDate = `${tdate.getDate()}/${tdate.getMonth()+2}/${tdate.getFullYear()}`
        }

        return (
            <tr>
                <td>{renderHTML(thisactionplan.heading)}</td>
                <td>{renderHTML(thisactionplan.action)}</td>
                <td>{displayDate}</td>
                <td>&nbsp;</td>
                <td>{renderHTML(thisactionplan.resources)}</td>
                <td className={`apstatus ${apcolor}`}>{apstatus}</td>
                <td></td>
            </tr>
        )
    }
}
const ActionPlanSubmodule = connect(mapStateToProps,mapDispatchToProps)(ConnectedActionPlanSubmodule);

export default ActionPlanSubmodule;